import {
  UNAVAILABLE_FEATURE_LOSSDRAFT,
  UNAVAILABLE_FEATURE_MULTIBORROWERUPLOAD,
  UNAVAILABLE_FEATURE_SECUREMESSAGING,
} from '@dmi/shared/redux/Main/constants';

export const getUnavailableFeaturesScreenNames = ({ unavailableFeaturesTreatment }) => {
  const unavailableScreenNames = [];

  if (unavailableFeaturesTreatment.includes(UNAVAILABLE_FEATURE_LOSSDRAFT)) {
    unavailableScreenNames.push('LossDraft');
  }
  if (unavailableFeaturesTreatment.includes(UNAVAILABLE_FEATURE_MULTIBORROWERUPLOAD)) {
    unavailableScreenNames.push('MailingAddressUploadDocument');
  }
  if (unavailableFeaturesTreatment.includes(UNAVAILABLE_FEATURE_SECUREMESSAGING)) {
    unavailableScreenNames.push('SecureMessaging');
  }

  return unavailableScreenNames;
};
